import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useVillage(subdistrict_id?: string) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const params: { [key: string]: number | string | undefined } = {};
  if (subdistrict_id) params.subdistrict_id = subdistrict_id;

  const refetch = (subdistrict_id?: string) => {
    setLoading(true)

    api.get("/villages/", {
      params: { subdistrict_id: subdistrict_id }
    }).then((res: SuccessFetch<{
      payload: {
        subdistrict_id?: string
        village_id: string
        village_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.village_name,
          value: item.village_id,
          subdistrict_id: item.subdistrict_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    api.get("/villages/", { params }).then((res: SuccessFetch<{
      payload: {
        subdistrict_id?: string
        village_id: string
        village_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.village_name,
          value: item.village_id,
          subdistrict_id: item.subdistrict_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}